var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#triangle-up';
                    var viewUrl = 'svg/icons.svg#view-triangle-up';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 20 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };